import { sendClick } from 'reaxl-analytics';

const seoLinksAnalytics = {
    fireReaxlSeoLinkClick(event, data) {
        sendClick('seoLinkClick', event, data);
    },
};
export default seoLinksAnalytics;
